import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AlertMessageComponent, AlertModule as CosoAlertModule } from "@coso/alert";
import { GridModule } from "@coso/grid";
import { UtilityModule } from "@coso/utility";
import { AlertModule } from "ngx-bootstrap/alert";
import { PaginationModule } from "ngx-bootstrap/pagination";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { PageHeaderModule } from "../../page-header/page-header.module";
import { OverwriteFolderPermissionsRoutingModule } from "./overwrite-folder-permissions-routing.module";
import { OverwriteFolderPermissionsComponent } from "./overwrite-folder-permissions.component";
import { SharePointDocumentLocationsService } from "./services/sharepoint-document-locations.service";

@NgModule({
  declarations: [OverwriteFolderPermissionsComponent],
  imports: [
    CommonModule,
    OverwriteFolderPermissionsRoutingModule,
    PageHeaderModule,
    AlertModule,
    CosoAlertModule,
    FormsModule,
    TooltipModule,
    PaginationModule,
    ReactiveFormsModule,
    GridModule,
    UtilityModule,
    AlertMessageComponent
  ],
  exports: [],
  providers: [SharePointDocumentLocationsService]
})
export class OverwriteFolderPermissionsModule {}
